import type React from 'react'
import { createContext, useContext, useState } from 'react'

const AudioContext = createContext<{
  currentAudio: HTMLAudioElement | null
  setCurrentAudio: (audio: HTMLAudioElement | null) => void
}>({
  currentAudio: null,
  setCurrentAudio: () => null,
})

export const useAudioContext = () => useContext(AudioContext)

export const AudioProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [currentAudio, setCurrentAudio] = useState<HTMLAudioElement | null>(
    null,
  )

  return (
    <AudioContext.Provider value={{ currentAudio, setCurrentAudio }}>
      {children}
    </AudioContext.Provider>
  )
}
